import $ from "jquery";
import Glide from "@glidejs/glide";

require("fslightbox");

const slider = () => {
  if (document.querySelector(".js-banner-slider")) {
    const bannerSlider = new Glide(".js-banner-slider", {
      type: "carousel",
      perView: 1,
      gap: 0,
      animationDuration: 500,
      autoplay: 5000,
      hoverpause: false,
      breakpoints: {
        1023: {
          autoplay: false,
        },
      },
    });

    let step = 0;
    bannerSlider.on("run", (arg) => {
      if (arg.direction === "<") {
        if (step <= 0) {
          step = window.sliderData.total_banner_slides - 1;
        } else {
          step -= 1;
        }
      } else if (arg.direction === ">") {
        if (step >= window.sliderData.total_banner_slides - 1) {
          step = 0;
        } else {
          step += 1;
        }
      }

      $("[data-banner-slide]").fadeOut(250, () => {
        setTimeout(() => {
          $(`[data-banner-slide="${step}"]`).fadeIn(250);
        }, 250);
      });
    });

    bannerSlider.mount();
  }

  if (document.querySelector(".js-job-slider")) {
    const jobSlider = new Glide(".js-job-slider", {
      type: "carousel",
      perView: 1,
      gap: 0,
      animationDuration: 500,
      autoplay: 5000,
      hoverpause: false,
      breakpoints: {
        1023: {
          autoplay: false,
        },
      },
    });
    jobSlider.mount();
    const resizeEvent = window.document.createEvent("UIEvents");
    resizeEvent.initUIEvent("resize", true, false, window, 0);
    window.dispatchEvent(resizeEvent);
  }

  if (document.querySelector(".js-estate-mobile-slider")) {
    const estateSlider = new Glide(".js-estate-mobile-slider", {
      type: "carousel",
      perView: 1,
      gap: 0,
      animationDuration: 500,
    });
    estateSlider.mount();
  }

  if (document.querySelector(".js-step-slider")) {
    const stepSlider = new Glide(".js-step-slider", {
      type: "carousel",
      perView: 2,
      gap: 80,
      animationDuration: 500,
      autoplay: false,
      peek: {
        before: 0,
        after: 200,
      },
      breakpoints: {
        1023: {
          perView: 1,
          gap: 35,
          peek: {
            before: 0,
            after: 50,
          },
        },
      },
    });

    $("[data-slider-prev=\"step\"]").on("click", () => {
      stepSlider.go("<");
    });

    $("[data-slider-next=\"step\"]").on("click", () => {
      stepSlider.go(">");
    });

    stepSlider.mount();
    const resizeEvent = window.document.createEvent("UIEvents");
    resizeEvent.initUIEvent("resize", true, false, window, 0);
    window.dispatchEvent(resizeEvent);
  }

  if (document.querySelector(".js-estate-slider")) {
    const totalSlides = $(".js-estate-slider").find("[data-glide-count]").attr("data-glide-count");
    let perView = 1;
    if (totalSlides > 1) {
      perView = 2;
    }
    const estateSlider = new Glide(".js-estate-slider", {
      type: "carousel",
      perView,
      gap: 10,
      animationDuration: 500,
      autoplay: false,
      breakpoints: {
        1023: {
          perView: 1,
        },
      },
    });

    $("[data-slider-prev]").on("click", () => {
      estateSlider.go("<");
    });

    $("[data-slider-next]").on("click", () => {
      estateSlider.go(">");
    });

    estateSlider.mount();
    const resizeEvent = window.document.createEvent("UIEvents");
    resizeEvent.initUIEvent("resize", true, false, window, 0);
    window.dispatchEvent(resizeEvent);
  }
};

export default slider;
